/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/BarcodeConfigurationTypes.yaml
import { PartiallyConstructible } from '../utils/utils';
/** @internal */
export var BarcodeFormatConfigurationBase;
(function (BarcodeFormatConfigurationBase) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'BarcodeFormatCodabarConfiguration':
                return new BarcodeFormatCodabarConfiguration(source);
            case 'BarcodeFormatCode11Configuration':
                return new BarcodeFormatCode11Configuration(source);
            case 'BarcodeFormatCode39Configuration':
                return new BarcodeFormatCode39Configuration(source);
            case 'BarcodeFormatCode93Configuration':
                return new BarcodeFormatCode93Configuration(source);
            case 'BarcodeFormatCode128Configuration':
                return new BarcodeFormatCode128Configuration(source);
            case 'BarcodeFormatCode2Of5Configuration':
                return new BarcodeFormatCode2Of5Configuration(source);
            case 'BarcodeFormatDataBarConfiguration':
                return new BarcodeFormatDataBarConfiguration(source);
            case 'BarcodeFormatDataBarExpandedConfiguration':
                return new BarcodeFormatDataBarExpandedConfiguration(source);
            case 'BarcodeFormatDataBarLimitedConfiguration':
                return new BarcodeFormatDataBarLimitedConfiguration(source);
            case 'BarcodeFormatITFConfiguration':
                return new BarcodeFormatItfConfiguration(source);
            case 'BarcodeFormatMSIPlesseyConfiguration':
                return new BarcodeFormatMsiPlesseyConfiguration(source);
            case 'BarcodeFormatUpcEanConfiguration':
                return new BarcodeFormatUpcEanConfiguration(source);
            case 'BarcodeFormatPharmaCodeConfiguration':
                return new BarcodeFormatPharmaCodeConfiguration(source);
            case 'BarcodeFormatAztecConfiguration':
                return new BarcodeFormatAztecConfiguration(source);
            case 'BarcodeFormatQRCodeConfiguration':
                return new BarcodeFormatQrCodeConfiguration(source);
            case 'BarcodeFormatPDF417Configuration':
                return new BarcodeFormatPdf417Configuration(source);
            case 'BarcodeFormatMicroPDF417Configuration':
                return new BarcodeFormatMicroPdf417Configuration(source);
            case 'BarcodeFormatDataMatrixConfiguration':
                return new BarcodeFormatDataMatrixConfiguration(source);
            case 'BarcodeFormatMaxiCodeConfiguration':
                return new BarcodeFormatMaxiCodeConfiguration(source);
            case 'BarcodeFormatAustraliaPostConfiguration':
                return new BarcodeFormatAustraliaPostConfiguration(source);
            case 'BarcodeFormatJapanPostConfiguration':
                return new BarcodeFormatJapanPostConfiguration(source);
            case 'BarcodeFormatRoyalMailConfiguration':
                return new BarcodeFormatRoyalMailConfiguration(source);
            case 'BarcodeFormatRoyalTNTPostConfiguration':
                return new BarcodeFormatRoyalTntPostConfiguration(source);
            case 'BarcodeFormatUSPSIntelligentMailConfiguration':
                return new BarcodeFormatUspsIntelligentMailConfiguration(source);
            case 'BarcodeFormatPharmaCodeTwoTrackConfiguration':
                return new BarcodeFormatPharmaCodeTwoTrackConfiguration(source);
            case 'BarcodeFormatGS1CompositeConfiguration':
                return new BarcodeFormatGs1CompositeConfiguration(source);
            case 'BarcodeFormatCommonOneDConfiguration':
                return new BarcodeFormatCommonOneDConfiguration(source);
            case 'BarcodeFormatCommonTwoDConfiguration':
                return new BarcodeFormatCommonTwoDConfiguration(source);
            case 'BarcodeFormatCommonFourStateConfiguration':
                return new BarcodeFormatCommonFourStateConfiguration(source);
            case 'BarcodeFormatCommonConfiguration':
                return new BarcodeFormatCommonConfiguration(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    BarcodeFormatConfigurationBase.From = From;
})(BarcodeFormatConfigurationBase || (BarcodeFormatConfigurationBase = {}));
/** @internal */
export var BarcodeFormatOneDConfigurationBase;
(function (BarcodeFormatOneDConfigurationBase) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'BarcodeFormatCodabarConfiguration':
                return new BarcodeFormatCodabarConfiguration(source);
            case 'BarcodeFormatCode11Configuration':
                return new BarcodeFormatCode11Configuration(source);
            case 'BarcodeFormatCode39Configuration':
                return new BarcodeFormatCode39Configuration(source);
            case 'BarcodeFormatCode93Configuration':
                return new BarcodeFormatCode93Configuration(source);
            case 'BarcodeFormatCode128Configuration':
                return new BarcodeFormatCode128Configuration(source);
            case 'BarcodeFormatCode2Of5Configuration':
                return new BarcodeFormatCode2Of5Configuration(source);
            case 'BarcodeFormatDataBarConfiguration':
                return new BarcodeFormatDataBarConfiguration(source);
            case 'BarcodeFormatDataBarExpandedConfiguration':
                return new BarcodeFormatDataBarExpandedConfiguration(source);
            case 'BarcodeFormatDataBarLimitedConfiguration':
                return new BarcodeFormatDataBarLimitedConfiguration(source);
            case 'BarcodeFormatITFConfiguration':
                return new BarcodeFormatItfConfiguration(source);
            case 'BarcodeFormatMSIPlesseyConfiguration':
                return new BarcodeFormatMsiPlesseyConfiguration(source);
            case 'BarcodeFormatUpcEanConfiguration':
                return new BarcodeFormatUpcEanConfiguration(source);
            case 'BarcodeFormatPharmaCodeConfiguration':
                return new BarcodeFormatPharmaCodeConfiguration(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    BarcodeFormatOneDConfigurationBase.From = From;
})(BarcodeFormatOneDConfigurationBase || (BarcodeFormatOneDConfigurationBase = {}));
/**
Codabar barcode configuration. Add to scanner configuration to scan Codabar barcodes.
*/
export class BarcodeFormatCodabarConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCodabarConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCodabarConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        /**
          If true, return the start and end characters.
          
          Default is false
          */
        this.returnStartEnd = false;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
        if (source.returnStartEnd !== undefined) {
            this.returnStartEnd = source.returnStartEnd;
        }
    }
}
/**
Code 11 barcode configuration. Add to scanner configuration to scan Code 11 barcodes.
*/
export class BarcodeFormatCode11Configuration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCode11Configuration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCode11Configuration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          If true, the check digits are stripped from the result.
          
          Default is false
          */
        this.stripCheckDigits = false;
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        /**
          If true, return CODE_11 barcodes only if they have a valid checksum.
          
          Default is true
          */
        this.checksum = true;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
        if (source.checksum !== undefined) {
            this.checksum = source.checksum;
        }
    }
}
/**
Code 39 barcode and derivatives configuration. Add to scanner configuration to scan Code 39, Code 32 (Italian Pharmacode), PZN7 and PZN8 (Pharmazentralnummer) barcodes.
*/
export class BarcodeFormatCode39Configuration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCode39Configuration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCode39Configuration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          If true, the check digits are stripped from the result.
          
          Default is false
          */
        this.stripCheckDigits = false;
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        /**
          If true, scan and return valid CODE_32 (Italian Pharmacode) barcodes. If false, CODE_32 barcodes are not decoded and are returned as CODE_39 instead.
          
          Default is false
          */
        this.code32 = false;
        /**
          If true, scan CODE_39 barcodes.
          
          Default is true
          */
        this.code39 = true;
        /**
          If true, scan PZN7 (legacy Pharmazentralnummer) barcodes. If false, PZN7 barcodes are not decoded and are returned as CODE_39 instead.
          
          Default is true
          */
        this.pzn7 = true;
        /**
          If true, scan PZN8 (Pharmazentralnummer) barcodes. If false, PZN8 barcodes are not decoded and are returned as CODE_39 instead.
          
          Default is true
          */
        this.pzn8 = true;
        /**
          If true, try to scan CODE_39 in extended mode.
          
          Default is false
          */
        this.tryCode39ExtendedMode = false;
        /**
          If true, return CODE_39 barcodes only if they have a valid check digit.
          
          Default is false
          */
        this.useCode39CheckDigit = false;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
        if (source.code32 !== undefined) {
            this.code32 = source.code32;
        }
        if (source.code39 !== undefined) {
            this.code39 = source.code39;
        }
        if (source.pzn7 !== undefined) {
            this.pzn7 = source.pzn7;
        }
        if (source.pzn8 !== undefined) {
            this.pzn8 = source.pzn8;
        }
        if (source.tryCode39ExtendedMode !== undefined) {
            this.tryCode39ExtendedMode = source.tryCode39ExtendedMode;
        }
        if (source.useCode39CheckDigit !== undefined) {
            this.useCode39CheckDigit = source.useCode39CheckDigit;
        }
    }
}
/**
Code 93 barcode configuration. Add to scanner configuration to scan Code 93 barcodes.
*/
export class BarcodeFormatCode93Configuration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCode93Configuration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCode93Configuration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          If true, the check digits are stripped from the result.
          
          Default is false
          */
        this.stripCheckDigits = false;
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
    }
}
/**
Code 128 barcode configuration. Add to scanner configuration to scan Code 128 barcodes.
*/
export class BarcodeFormatCode128Configuration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCode128Configuration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCode128Configuration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
    }
}
/**
Configuration for all 2-of-5 barcode types (except Interleaved 2-of-5, which is handled by ItfConfig).
Add to scanner configuration to scan Code 25, IATA 2-of-5 and Industrial 2-of-5 barcodes.

Industrial 2-of-5 barcodes are a subset of Code 25 barcodes.
Any valid Industrial 2-of-5 barcode is also a valid Code 25 barcode.
*/
export class BarcodeFormatCode2Of5Configuration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCode2Of5Configuration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCode2Of5Configuration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          If true, the check digits are stripped from the result.
          
          Default is false
          */
        this.stripCheckDigits = false;
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        /**
          If true, scan IATA 2-of-5 barcodes. If useIATA2OF5Checksum is true, only barcodes with a valid checksum are returned.
          
          Default is true
          */
        this.iata2of5 = true;
        /**
          If true, scan and return Code 25 (Code 2-of-5) barcodes. If industrial2of5 is also true, then valid Industrial 2-of-5 barcodes will preferentially be returned as such, instead of Code 25.
          
          Default is false
          */
        this.code25 = false;
        /**
          If true, scan and return valid Industrial 2-of-5 barcodes. If false, but code25 is true, Industrial 2-of-5 barcodes will be returned as Code 25 barcodes.
          
          Default is true
          */
        this.industrial2of5 = true;
        /**
          If true, return IATA_2_OF_5 barcodes only if they have a valid check digit.
          
          Default is true
          */
        this.useIATA2OF5Checksum = true;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
        if (source.iata2of5 !== undefined) {
            this.iata2of5 = source.iata2of5;
        }
        if (source.code25 !== undefined) {
            this.code25 = source.code25;
        }
        if (source.industrial2of5 !== undefined) {
            this.industrial2of5 = source.industrial2of5;
        }
        if (source.useIATA2OF5Checksum !== undefined) {
            this.useIATA2OF5Checksum = source.useIATA2OF5Checksum;
        }
    }
}
/**
GS1 DataBar barcode configuration. Add to scanner configuration to scan GS1 DataBar-14, GS1 DataBar-14 Truncated, GS1 DataBar-14 Stacked and GS1 DataBar-14 Stacked Omnidirectional barcodes.
*/
export class BarcodeFormatDataBarConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatDataBarConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatDataBarConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
    }
}
/**
GS1 DataBar Expanded barcode configuration. Add to scanner configuration to scan GS1 DataBar Expanded and GS1 DataBar Expanded Stacked barcodes.
*/
export class BarcodeFormatDataBarExpandedConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatDataBarExpandedConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatDataBarExpandedConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
    }
}
/**
GS1 DataBar Limited barcode configuration. Add to scanner configuration to scan GS1 DataBar Limited barcodes.
*/
export class BarcodeFormatDataBarLimitedConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatDataBarLimitedConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatDataBarLimitedConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
    }
}
/**
ITF (Interleaved 2-of-5) barcode configuration. Add to scanner configuration to scan Interleaved 2-of-5 (ITF) barcodes.
*/
export class BarcodeFormatItfConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatItfConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatITFConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
    }
}
export const MsiPlesseyChecksumAlgorithmValues = [
    'MOD_10',
    'MOD_11_IBM',
    'MOD_11_NCR',
    'MOD_10_10',
    'MOD_11_10_IBM',
    'MOD_11_10_NCR',
];
/**
MSI Plessey barcode configuration. Add to scanner configuration to scan MSI Plessey barcodes.
*/
export class BarcodeFormatMsiPlesseyConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatMsiPlesseyConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatMSIPlesseyConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          If true, the check digits are stripped from the result.
          
          Default is false
          */
        this.stripCheckDigits = false;
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        /**
          List of MSI Plessey checksum algorithms to apply during scanning.
          A barcode is considered valid if it passes any of the checksum algorithms in the list.
          If the list is empty, no checksum validation is performed.
          */
        this.checksumAlgorithms = ['MOD_10'];
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
        if (source.checksumAlgorithms !== undefined) {
            this.checksumAlgorithms = source.checksumAlgorithms.map((it) => {
                return it;
            });
        }
    }
}
/**
UPC/EAN barcode configuration. Add to scanner configuration to scan EAN-8, EAN-13, UPC-E and UPC-A barcodes.
*/
export class BarcodeFormatUpcEanConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatUpcEanConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatUpcEanConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          If true, the check digits are stripped from the result.
          
          Default is false
          */
        this.stripCheckDigits = false;
        /**
          If true, scan and return valid EAN-8 barcodes.
          
          Default is true
          */
        this.ean8 = true;
        /**
          If true, scan and return valid EAN-13 barcodes.
          
          Default is true
          */
        this.ean13 = true;
        /**
          If true, scan and return valid UPC-A barcodes. If false, but ean13 is true, then UPC-A barcodes will be returned as EAN-13 barcodes.
          
          Default is true
          */
        this.upca = true;
        /**
          If true, scan and return valid UPC-E barcodes.
          
          Default is true
          */
        this.upce = true;
        /**
          Behavior when scanning UPC/EAN barcodes with EAN-2 or EAN-5 extensions.
          
          Default is ALLOW_ANY
          */
        this.extensions = 'ALLOW_ANY';
        /**
          In case that EAN/UPC barcodes both with and without extensions are allowed,
          we require this number of frames on which the standalone EAN or UPC (i.e. without extension) has to be detected to be considered as valid (live scanning only).
          EAN/UPC barcodes with extensions are more prone to slicing (incomplete decoding).
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability that an extension is accidentally missed.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResultExtensionless = 1;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
        if (source.ean8 !== undefined) {
            this.ean8 = source.ean8;
        }
        if (source.ean13 !== undefined) {
            this.ean13 = source.ean13;
        }
        if (source.upca !== undefined) {
            this.upca = source.upca;
        }
        if (source.upce !== undefined) {
            this.upce = source.upce;
        }
        if (source.extensions !== undefined) {
            this.extensions = source.extensions;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResultExtensionless !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResultExtensionless =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResultExtensionless;
        }
    }
}
/**
PharmaCode barcode configuration. Add to scanner configuration to scan linear (1D) Laetus Pharmacode barcodes. Two-track PharmaCode scanning is configured separately through the PharmaCodeTwoTrackConfig class.
*/
export class BarcodeFormatPharmaCodeConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatPharmaCodeConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatPharmaCodeConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          Minimum value for PharmaCode. Very low values are likely to produce more false positives.
          
          Default is 16
          */
        this.minimumValue = 16;
        /**
          If true, a result consisting of only narrow bars is accepted as valid. The specification does not recommend such barcodes. Default is false.
          
          Default is false
          */
        this.allowNarrowBarsOnly = false;
        /**
          If true, a result consisting of only wide bars is accepted as valid. The specification does not recommend such barcodes. Default is false.
          
          Default is false
          */
        this.allowWideBarsOnly = false;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.minimumValue !== undefined) {
            this.minimumValue = source.minimumValue;
        }
        if (source.allowNarrowBarsOnly !== undefined) {
            this.allowNarrowBarsOnly = source.allowNarrowBarsOnly;
        }
        if (source.allowWideBarsOnly !== undefined) {
            this.allowWideBarsOnly = source.allowWideBarsOnly;
        }
    }
}
/** @internal */
export var BarcodeFormatTwoDConfigurationBase;
(function (BarcodeFormatTwoDConfigurationBase) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'BarcodeFormatAztecConfiguration':
                return new BarcodeFormatAztecConfiguration(source);
            case 'BarcodeFormatQRCodeConfiguration':
                return new BarcodeFormatQrCodeConfiguration(source);
            case 'BarcodeFormatPDF417Configuration':
                return new BarcodeFormatPdf417Configuration(source);
            case 'BarcodeFormatMicroPDF417Configuration':
                return new BarcodeFormatMicroPdf417Configuration(source);
            case 'BarcodeFormatDataMatrixConfiguration':
                return new BarcodeFormatDataMatrixConfiguration(source);
            case 'BarcodeFormatMaxiCodeConfiguration':
                return new BarcodeFormatMaxiCodeConfiguration(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    BarcodeFormatTwoDConfigurationBase.From = From;
})(BarcodeFormatTwoDConfigurationBase || (BarcodeFormatTwoDConfigurationBase = {}));
/**
Aztec configuration. Add to scanner configuration to scan Aztec codes.
*/
export class BarcodeFormatAztecConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatAztecConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatAztecConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
    }
}
/**
QR Code configuration. Add to scanner configuration to scan QR codes, Micro QR codes and rectangular Micro QR (rMQR) codes.
*/
export class BarcodeFormatQrCodeConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatQrCodeConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatQRCodeConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        /**
          If true, the barcode scanner will only return barcodes that pass the strict validation checks according to standards to avoid false positives.
          
          Default is true
          */
        this.strictMode = true;
        /**
          If true, scan and return QR codes.
          
          Default is true
          */
        this.qr = true;
        /**
          If true, scan and return Micro QR codes.
          
          Default is false
          */
        this.microQr = false;
        /**
          If true, scan and return rectangular Micro QR (rMQR) codes.
          
          Default is false
          */
        this.rmqr = false;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
        if (source.strictMode !== undefined) {
            this.strictMode = source.strictMode;
        }
        if (source.qr !== undefined) {
            this.qr = source.qr;
        }
        if (source.microQr !== undefined) {
            this.microQr = source.microQr;
        }
        if (source.rmqr !== undefined) {
            this.rmqr = source.rmqr;
        }
    }
}
/**
PDF417 configuration. Add to scanner configuration to scan PDF417 codes.
*/
export class BarcodeFormatPdf417Configuration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatPdf417Configuration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatPDF417Configuration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        /**
          If true, the barcode scanner will only return barcodes that pass the strict validation checks according to standards to avoid false positives.
          
          Default is true
          */
        this.strictMode = true;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
        if (source.strictMode !== undefined) {
            this.strictMode = source.strictMode;
        }
    }
}
/**
MicroPDF417 configuration. Add to scanner configuration to scan MicroPDF417 codes.
*/
export class BarcodeFormatMicroPdf417Configuration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatMicroPdf417Configuration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatMicroPDF417Configuration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        /**
          If true, the barcode scanner will only return barcodes that pass the strict validation checks according to standards to avoid false positives.
          
          Default is true
          */
        this.strictMode = true;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
        if (source.strictMode !== undefined) {
            this.strictMode = source.strictMode;
        }
    }
}
/**
DataMatrix configuration. Add to scanner configuration to scan DataMatrix and DataMatrix rectangular extensions (DMRE) codes.
*/
export class BarcodeFormatDataMatrixConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatDataMatrixConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatDataMatrixConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
    }
}
/**
MaxiCode configuration. Add to scanner configuration to scan MaxiCode codes.
*/
export class BarcodeFormatMaxiCodeConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatMaxiCodeConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatMaxiCodeConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
    }
}
/** @internal */
export var BarcodeFormatFourStateConfigurationBase;
(function (BarcodeFormatFourStateConfigurationBase) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'BarcodeFormatAustraliaPostConfiguration':
                return new BarcodeFormatAustraliaPostConfiguration(source);
            case 'BarcodeFormatJapanPostConfiguration':
                return new BarcodeFormatJapanPostConfiguration(source);
            case 'BarcodeFormatRoyalMailConfiguration':
                return new BarcodeFormatRoyalMailConfiguration(source);
            case 'BarcodeFormatRoyalTNTPostConfiguration':
                return new BarcodeFormatRoyalTntPostConfiguration(source);
            case 'BarcodeFormatUSPSIntelligentMailConfiguration':
                return new BarcodeFormatUspsIntelligentMailConfiguration(source);
            case 'BarcodeFormatPharmaCodeTwoTrackConfiguration':
                return new BarcodeFormatPharmaCodeTwoTrackConfiguration(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    BarcodeFormatFourStateConfigurationBase.From = From;
})(BarcodeFormatFourStateConfigurationBase || (BarcodeFormatFourStateConfigurationBase = {}));
export const AustraliaPostCustomerFormatValues = ['NUMERIC', 'ALPHA_NUMERIC'];
/**
Australia Post barcode configuration. Add to scanner configuration to scan Australia Post barcodes.
*/
export class BarcodeFormatAustraliaPostConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatAustraliaPostConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatAustraliaPostConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Can be either numeric or alphanumeric and is only relevant for Format Codes 59 and 62.
          
          Default is ALPHA_NUMERIC
          */
        this.australiaPostCustomerFormat = 'ALPHA_NUMERIC';
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.australiaPostCustomerFormat !== undefined) {
            this.australiaPostCustomerFormat = source.australiaPostCustomerFormat;
        }
    }
}
/**
Japan Post barcode configuration. Add to scanner configuration to scan Japan Post barcodes.
*/
export class BarcodeFormatJapanPostConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatJapanPostConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatJapanPostConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
    }
}
/**
Royal Mail barcode configuration. Add to scanner configuration to scan Royal Mail (a.k.a. RM4SCC, CBC, BPO 4-State) barcodes.
*/
export class BarcodeFormatRoyalMailConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatRoyalMailConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatRoyalMailConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          If true, the check digits are stripped from the result.
          
          Default is false
          */
        this.stripCheckDigits = false;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
    }
}
/**
Royal TNT Post barcode configuration. Add to scanner configuration to scan Royal TNT Post (a.k.a. KIX, Klant IndeX) barcodes.
*/
export class BarcodeFormatRoyalTntPostConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatRoyalTntPostConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatRoyalTNTPostConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
    }
}
/**
USPS Intelligent Mail barcode configuration. Add to scanner configuration to scan USPS Intelligent Mail (a.k.a. USPS OneCode, USPS-STD-11) barcodes.
*/
export class BarcodeFormatUspsIntelligentMailConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatUspsIntelligentMailConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatUSPSIntelligentMailConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
    }
}
/**
PHARMA_CODE_TWO_TRACK barcode configuration. Add to scanner configuration to scan Laetus two-track PharmaCode barcodes. Linear (i.e. one-track) PharmaCode scanning is configured separately through the PharmaCodeConfig class.
*/
export class BarcodeFormatPharmaCodeTwoTrackConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatPharmaCodeTwoTrackConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatPharmaCodeTwoTrackConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum value for PHARMA_CODE_TWO_TRACK. Very low values are likely to produce more false positives.
          
          Default is 364
          */
        this.minimumValue = 364;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimumValue !== undefined) {
            this.minimumValue = source.minimumValue;
        }
    }
}
/**
GS1 Composite configuration. Add to scanner configuration to scan GS1 Composite barcodes.

When not enabled, the individual parts of GS1 Composite barcodes will be returned as separate items,
if the respective formats are enabled (UPC-A, Code 128, MicroPDF417, PDF417).
Those barcode items will have their isGS1CompositePart field set to true.
If GS1 Composite scanning is enabled, the individual parts are never returned, even if their respective formats
are enabled, except when the linear component is a UPC or EAN barcode. In that case the linear component might still
occasionally be returned as a separate result. If this situation needs to be avoided, remove the UPC and EAN formats from
the enabled formats.

If GS1 Composite scanning is disabled, but GS1 message validation is enabled, then the parts of the composite barcode may
fail validation and be rejected.
*/
export class BarcodeFormatGs1CompositeConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatGs1CompositeConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatGS1CompositeConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        /**
          If true, the barcode scanner will only return barcodes that pass the strict validation checks according to standards to avoid false positives.
          
          Default is true
          */
        this.strictMode = true;
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
        if (source.strictMode !== undefined) {
            this.strictMode = source.strictMode;
        }
    }
}
/**
Convenience configuration for enabling the scanning of multiple linear (1D) barcode formats with a common configuration.
Add to scanner configuration to enable and configure the scanning of multiple linear (1D) barcode formats.

The given configuration will be applied to all enabled barcode formats, if they support it.
You can override the common configuration for individual barcode formats by additionally adding
their specific configuration to the scanner's configuration.
*/
export class BarcodeFormatCommonOneDConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCommonOneDConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCommonOneDConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          If true, the check digits are stripped from the result.
          
          Default is false
          */
        this.stripCheckDigits = false;
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        /**
          List of linear (1D) barcode formats to scan.
          */
        this.formats = [
            'CODABAR',
            'CODE_11',
            'CODE_25',
            'CODE_32',
            'CODE_39',
            'CODE_93',
            'CODE_128',
            'DATABAR',
            'DATABAR_EXPANDED',
            'DATABAR_LIMITED',
            'EAN_8',
            'EAN_13',
            'IATA_2_OF_5',
            'INDUSTRIAL_2_OF_5',
            'ITF',
            'MSI_PLESSEY',
            'PHARMA_CODE',
            'PZN_7',
            'PZN_8',
            'UPC_A',
            'UPC_E',
        ];
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
        if (source.formats !== undefined) {
            this.formats = source.formats.map((it) => {
                return it;
            });
        }
    }
}
/**
Convenience configuration for enabling the scanning of multiple 2D codes with a common configuration.
Add to scanner configuration to enable and configure the scanning of multiple 2D codes.

The given configuration will be applied to all enabled barcode formats, if they support it.
You can override the common configuration for individual barcode formats by additionally adding
their specific configuration to the scanner's configuration.
*/
export class BarcodeFormatCommonTwoDConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCommonTwoDConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCommonTwoDConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        /**
          If true, the barcode scanner will only return barcodes that pass the strict validation checks according to standards to avoid false positives.
          
          Default is true
          */
        this.strictMode = true;
        /**
          List of 2D codes to scan.
          */
        this.formats = [
            'AZTEC',
            'DATA_MATRIX',
            'MAXI_CODE',
            'MICRO_QR_CODE',
            'MICRO_PDF_417',
            'PDF_417',
            'QR_CODE',
            'RMQR_CODE',
        ];
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
        if (source.strictMode !== undefined) {
            this.strictMode = source.strictMode;
        }
        if (source.formats !== undefined) {
            this.formats = source.formats.map((it) => {
                return it;
            });
        }
    }
}
/**
Convenience configuration for enabling the scanning of multiple four-state barcode formats with a common configuration.
Add to scanner configuration to enable and configure the scanning of multiple four-state codes.

The given configuration will be applied to all enabled barcode formats, if they support it.
You can override the common configuration for individual barcode formats by additionally adding
their specific configuration to the scanner's configuration.
*/
export class BarcodeFormatCommonFourStateConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCommonFourStateConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCommonFourStateConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          List of four-state barcode formats to scan.
          */
        this.formats = [
            'AUSTRALIA_POST',
            'JAPAN_POST',
            'ROYAL_MAIL',
            'ROYAL_TNT_POST',
            'USPS_INTELLIGENT_MAIL',
        ];
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.formats !== undefined) {
            this.formats = source.formats.map((it) => {
                return it;
            });
        }
    }
}
/**
Convenience configuration for enabling the scanning of multiple barcode formats with a common configuration.
Add to scanner configuration to enable and configure the scanning of multiple barcodes.

The given configuration will be applied to all enabled barcode formats, if they support it.
You can override the common configuration for individual barcode formats by additionally adding
their specific configuration to the scanner's configuration.
*/
export class BarcodeFormatCommonConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormatCommonConfiguration>`} */
    constructor(source = {}) {
        super();
        this._type = 'BarcodeFormatCommonConfiguration';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off).
          
          Default is ""
          */
        this.regexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1).
          Barcodes with a sizeScore less than this value will not be scanned.
          When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          If true, we process the barcode scanning with an artificial quiet zone that we add to the input image.
          This flag should be used to scan sharp crops of a barcode in single-shot mode.
          
          Default is false
          */
        this.addAdditionalQuietZone = false;
        /**
          Minimum quiet zone size on the left and right sides of a 1D barcode, measured in number of modules.
          The quiet zone is only for 1D barcodes with weak start/stop patterns, i.e. Iata2Of5, Industrial2Of5, Code25, Itf, Codabar, MsiPlessey and Code11.
          
          Default is 6
          */
        this.minimum1DQuietZoneSize = 6;
        /**
          Minimum number of frames on which a linear (1D) barcode has to be detected to be considered valid (live scanning only).
          Linear barcodes are more prone to false positives.
          Increasing the number of frames on which a barcode has to decode to the same content reduces the probability of a false positive.
          
          Default is 1
          */
        this.minimumNumberOfRequiredFramesWithEqualRecognitionResult = 1;
        /**
          If true, the check digits are stripped from the result.
          
          Default is false
          */
        this.stripCheckDigits = false;
        /**
          Minimum text length. Applied only to linear barcode formats that allow variable length.
          
          Default is 1
          */
        this.minimumTextLength = 1;
        /**
          Maximum text length. 0 implies no maximum. Applied only to linear barcode formats that allow variable length.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        /**
          GS1 message handling options.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        /**
          If true, the barcode scanner will only return barcodes that pass the strict validation checks according to standards to avoid false positives.
          
          Default is true
          */
        this.strictMode = true;
        /**
          List of barcode formats to scan. By default, the most commonly used formats are enabled.
          */
        this.formats = [
            'AZTEC',
            'CODABAR',
            'CODE_39',
            'CODE_93',
            'CODE_128',
            'DATA_MATRIX',
            'DATABAR',
            'DATABAR_EXPANDED',
            'DATABAR_LIMITED',
            'EAN_13',
            'EAN_8',
            'ITF',
            'MICRO_QR_CODE',
            'PDF_417',
            'QR_CODE',
            'UPC_A',
            'UPC_E',
        ];
        if (source.regexFilter !== undefined) {
            this.regexFilter = source.regexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.addAdditionalQuietZone !== undefined) {
            this.addAdditionalQuietZone = source.addAdditionalQuietZone;
        }
        if (source.minimum1DQuietZoneSize !== undefined) {
            this.minimum1DQuietZoneSize = source.minimum1DQuietZoneSize;
        }
        if (source.minimumNumberOfRequiredFramesWithEqualRecognitionResult !== undefined) {
            this.minimumNumberOfRequiredFramesWithEqualRecognitionResult =
                source.minimumNumberOfRequiredFramesWithEqualRecognitionResult;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
        if (source.strictMode !== undefined) {
            this.strictMode = source.strictMode;
        }
        if (source.formats !== undefined) {
            this.formats = source.formats.map((it) => {
                return it;
            });
        }
    }
}
//# sourceMappingURL=BarcodeConfigurationTypes.js.map